module.exports = __webpack_public_path__ + "static/media/warehouse.390d29ef.glb";